import {
  SlideOutModal,
  SlideOutModalProps,
} from "../../../components";
import { useEffect, useState } from "react";
import { ProviderServicesAddPage, ProviderAddAllServicesPage, ProviderServicesAddTopbar } from "../";

export interface AddProviderServiceModalProps extends SlideOutModalProps {
  providerId: number;
  addService: any;
  addServiceTypeServices: any;
}

export function AddProviderServiceModal(props: Readonly<AddProviderServiceModalProps>) {

  const [activeTab, setActiveTab] = useState<string>('Add Service');

  useEffect(() => {
    setActiveTab('Add Service');
  }, [props.providerId])

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <SlideOutModal
      {...props}
      title={"Add New Service"}
      bodyClassName="p-0"
      topbar={
        <ProviderServicesAddTopbar onChangeTab={handleTabChange} />
      }
      onHide={() => { setActiveTab('Add Service') }}
    >
      {activeTab === 'Add Service' && (
        <ProviderServicesAddPage showState={props.showState} providerId={props.providerId} onSubmit={props.addService} />
      )}
      {activeTab === 'Add Service Type' && (
        <ProviderAddAllServicesPage showState={props.showState} providerId={props.providerId} onSubmit={props.addServiceTypeServices} />
      )}
    </SlideOutModal>
  );
}

export default AddProviderServiceModal;
